<template>
  <div>
    <ca-heading text="Exportação de Movimentos" />

    <ca-row>
      <ca-col offset="9" size="3">
        <ca-monthpicker v-model="selectedDate"></ca-monthpicker>
      </ca-col>
    </ca-row>

    <ca-async-content-wrapper
      :key="contentKey"
      :on-fetch="getMovementFiles"
      :on-fetch-success="setMovementFiles">
      <ca-form
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row vertical-offset="2">
          <ca-col>
            <ca-table>
              <ca-tr slot="header">
                <ca-th align="center" size="1">Agrupar</ca-th>
                <ca-th size="6">Evento</ca-th>
                <ca-th size="2">Conta Débito</ca-th>
                <ca-th size="2">Conta Crédito</ca-th>
              </ca-tr>

              <ca-tr v-for="(movement, index) in movemementFiles" :key="index">
                <ca-td align="center">
                  <ca-checkbox v-model="movement.agrupamento" />
                </ca-td>
                <ca-td>{{ movement.descricao }}</ca-td>
                <ca-td>
                  <ca-input
                    v-model="movement.contaDebito"
                    maxlength="20"
                    required></ca-input>
                </ca-td>
                <ca-td>
                  <ca-input
                    v-model="movement.contaCredito"
                    maxlength="20"
                    required></ca-input>
                </ca-td>
              </ca-tr>
            </ca-table>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col offset="10" size="2">
              <ca-submit-button>
                Gerar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-async-content-wrapper>
  </div>
</template>

<script>
import moment from 'moment';
import { getBoxInformationErrorMessage } from 'packages/common/utils';
import { getMovementFiles, editMovementFiles } from './movementService';

export default {
  name: 'MovementFilePage',
  data() {
    return {
      contentKey: 0,
      movemementFiles: null,
      selectedDate: moment().format('DD/MM/YYYY'),
      errorMessage: null,
    };
  },
  watch: {
    selectedDate() {
      this.updateList();
    },
  },
  methods: {
    getMovementFiles() {
      return getMovementFiles(this.selectedDate);
    },
    setMovementFiles(response) {
      this.movemementFiles = response;
    },
    onSubmit() {
      return editMovementFiles(this.selectedDate, this.movemementFiles);
    },
    onSubmitSuccess() {
      this.$toaster.success('CSV baixado com sucesso!');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    goBack() {
      this.$router.push({ name: 'MovementFilePage' });
    },
    updateList() {
      this.contentKey++;
    },
  },
};
</script>
